export default __webpack_public_path__ + "static/media/aging@3x.4eeb006e.png";